/**
 * Route for `creative-ab`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CreativeAbPage } from "../features/creative-ab/CreativeAbPage";

export const creativeAbRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/creative-ab",
	component: CreativeAbPage,
});

export default creativeAbRoute;
